import React, { Component } from 'react';
import correctSymbol from '../../assets/correct-symbol.png'
import noStopping from '../../assets/no-stopping.png'

export default () => {
  return (
    <div className="tab-pane fade show active" id="pills-terdaftar" role="tabpanel" aria-labelledby="pills-terdaftar-tab">
      <table className="table-bordered table table-syarat" style={{fontSize: '12px'}}>
        <tr>
          <td colspan="2" style={{fontWeight: '600'}}>Persyaratan</td>
          <td>PSrE Non Instansi</td>
          <td>PSrE Instansi</td>
          <td>PSrE Asing</td>
        </tr>
        <tr>
          <td className="text-center">1</td>
          <td>Terdaftar Sebagai Penyelenggara Sistem Elektronik (PSE)</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">2</td>
          <td>Akta Pendirian Usaha</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">3</td>
          <td>Izin Usaha Bidang Teknologi Informasi</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={noStopping} alt="no-stopping" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">4</td>
          <td>Surat Pernyataan Fasilitas dan Peralatan di Indonesia</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={noStopping} alt="no-stopping" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">5</td>
          <td>Prosedur Pengoperasian Fasilitas dan Peralatan</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={noStopping} alt="no-stopping" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">6</td>
          <td>Business Plan, Laporan Stress Test, Load Test & Penetration Test</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={noStopping} alt="no-stopping" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">7</td>
          <td>Memiliki CP/CPS</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">8</td>
          <td>Surat Permohonan (Lampiran 1 PM Kominfo 11/2018)</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={noStopping} alt="no-stopping" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">9</td>
          <td>Proposal Kelengkapan (Lampiran 2 PM Kominfo 11/2018)</td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={noStopping} alt="no-stopping" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
        <tr>
          <td className="text-center">10</td>
          <td>Dikenali Minimal 3 (tiga) Browser Popular</td>
          <td><img src={noStopping} alt="no-stopping" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={noStopping} alt="no-stopping" style={{height:' 15px', width: 'auto'}}/></td>
          <td><img src={correctSymbol} alt="correct-symbol" style={{height:' 15px', width: 'auto'}}/></td>
        </tr>
      </table>
    </div>
  )
}
